import { Injectable } from "@angular/core";
import {
  ApiService,
  FeatureMappingGetDto,
  PermissionCategoryDto,
  PermissionMappingGetDto,
  SubscriptionAddons,
  SubscriptionPlan,
  SubscriptionPlanFilterPostDto,
  SubscriptionPlansWithAddonsGetDto,
  SubscriptionPlanType
} from "clearline-api";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class SubscriptionPlanService {
  protected serviceUrl = "SubscriptionPlan";
  constructor(protected http: ApiService) {}

  /** Usage: https://clearline.atlassian.net/browse/PT-253?focusedCommentId=19055 */
  getFilteredPlans(filter: SubscriptionPlanFilterPostDto): Observable<SubscriptionPlan[]> {
    return this.http.post(`${this.serviceUrl}/filter`, filter);
  }

  getList(sourceType: SubscriptionPlanType): Observable<SubscriptionPlan[]> {
    return this.http.get(`${this.serviceUrl}/${sourceType}`);
  }

  getAllWithAddons(filter: SubscriptionPlanFilterPostDto): Observable<SubscriptionPlansWithAddonsGetDto> {
    return this.http.post(`${this.serviceUrl}/all`, filter);
  }

  getByProduct(productId: string): Observable<SubscriptionPlan> {
    return this.http.get(`${this.serviceUrl}/byProduct/${productId}`);
  }

  getLocationPlan(locationId: number): Observable<SubscriptionPlan> {
    return this.http.getRaw(`${this.serviceUrl}/locationPlan/${locationId}`);
  }

  getAddons(): Observable<SubscriptionAddons[]> {
    return this.http.get(`${this.serviceUrl}/addons`);
  }

  /** @deprecated */
  getFeatureMappings(): Observable<FeatureMappingGetDto[]> {
    return this.http.get(`${this.serviceUrl}/featureMappings`);
  }

  getPermissionMappings(): Observable<PermissionMappingGetDto[]> {
    return this.http.get(`${this.serviceUrl}/permissionMappings`);
  }

  getPermissionMappingsByCategory(category: PermissionCategoryDto): Observable<PermissionMappingGetDto[]> {
    return this.http.get(`${this.serviceUrl}/permissionMappings/${category}`);
  }
}
